module.exports = __webpack_public_path__ + "static/img/8.e55dd4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-trans-mercancias-especifico/8.png
// module id = 2Y9u
// module chunks = 0